export default {"src":"/_next/static/image/public/assets/icons/globe.e77a2b00e460bf09fb93756a819f4bae.svg","height":20,"width":20};